<template>
    <div class="col-12 px-2 my-2">
        <ListTable :bills="bills" class="mb-2"/>
        <Pagination
            :offset="offset"
            @onPageChange="onPageChange"
            ref="pagination"
        />
        <AppointmentModal 
            v-if="$store.state.isModalOpen"
            @onSubmit="getOPDBillings"
        />
        <Loader v-if="loading"/>
    </div>
</template>
<script setup>
import ListTable from '@/components/molecule/company/dental-os/single-service/appointment/components/AppointmentListTable.vue';
import AppointmentModal from '@/components/molecule/company/dental-os/single-service/appointment/components/AppointmentModal.vue';
import {useRoute, useRouter} from "vue-router";
import handleHospitalBilling from "@/services/modules/hospital/billing";
import {computed, inject, onMounted, ref} from "vue";
import Loader from "@/components/atom/LoaderComponent.vue";
import Pagination from "@/components/atom/Pagination.vue";
import {useStore} from "vuex";

const $route = useRoute();
const $router = useRouter();
const $store = useStore();

const props = defineProps({
    patientId: {
        type: [Number, String, null],
        default: null
    },
    serialNo: {
        type: [String, null],
        default: null
    },
    consultantId: {
        type: [String, Number, null],
        default: null
    }
})

const showError = inject('showError');
const {fetchOPDBillings} = handleHospitalBilling();

const offset = ref(10);
const loading = ref(false);
const bills = ref([])
const start = computed(() => $route.query.start);
const end = computed(() => $route.query.end);
const page = computed(() => $route.query.page);
const companyId = computed(() => $route.params.companyId);

const setPaginationData = (data) => {
    $store.commit('setPaginationData', data)
};

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, $route.query)
    routeQuery.page = page
    await $router.push({path: $route.path, query: routeQuery})
    await getOPDBillings()
}

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const getQuery = () => {
    let query = '?company_id=' + companyId.value
    if (!start && !end) return query
    if (start) query += '&start_date=' + start.value
    if (end) query += '&end_date=' + end.value
    query += '&offset=' + offset.value
    query += '&except_sale_master=1'
    query += '&service_type=dental_os'
    if (page) query += '&page=' + page.value
    if (props.patientId) query += '&patient_id=' + props.patientId
    if (props.serialNo) query += '&serial_no=' + props.serialNo
    if (props.consultantId) query += '&service_resource_id=' + props.consultantId
    return query
};

async function getOPDBillings() {
    loading.value = true;
    try {
        const res = await fetchOPDBillings(getQuery());
        if (!res.status) {
            bills.value = []
            return $store.commit("resetPagination")
        }

        bills.value = res.data.data;
        
        if (bills.value.length > 0) {
            setPagination(res.data)
        }
    } catch (err) {
        if (err.response) {
            showError(err.response.message)
        }
    } finally {
        loading.value = false;
    }
}

onMounted(() => {
    getOPDBillings()
})

defineExpose({
    getOPDBillings
})
</script>
